import { Box, Button } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { primaryColorBlack } from "../../../utils/styles";
import customButtonStyles from "./CustomButton.styles";

interface CustomProps {
  label: string;
  onClick: Function;
  variant?: "contained" | "outlined" | "text";
  loading?: boolean;
  customClasses?: any;
  buttonType?: string;
  startIcon?: JSX.Element;
  endIcon?: JSX.Element;
  disabled?: boolean;
}

const CustomButton = (props: CustomProps) => {
  const getCustomCss = () => {
    switch (props.buttonType) {
      case "primaryBtn":
        return classes.primaryBtn;
      case "secondaryBtn":
        return classes.secondaryBtn;
      default:
        return {};
    }
  };

  const classes = customButtonStyles;
  const buttonType = getCustomCss();
  const appliedClass = {
    ...classes.btnStyle,
    ...buttonType,
    ...(props.customClasses ?? {}),
  };

  const processing = props.loading ? props.loading : false;

  return (
    <Button
      variant={props.variant}
      startIcon={props.startIcon}
      endIcon={props.endIcon}
      sx={appliedClass}
      onClick={(event) => props.onClick(event)}
      disabled={props.loading ?? props.disabled}
    >
      {processing ? (
        <Box sx={classes.loading}>
          <CircularProgress size={20} sx={{ color: primaryColorBlack }} />
        </Box>
      ) : (
        props.label
      )}
    </Button>
  );
};

export default CustomButton;
